import type { ReactNode } from 'react'
import styles from './Section.module.css'

interface Props {
  /** Заголовок экрана или раздела. В макете — 48/52 на десктопе. */
  title: ReactNode
  /** Кнопки справа от заголовка (например «Создать»). */
  actions?: ReactNode
  children?: ReactNode
}

/**
 * Раздел экрана: крупный заголовок и содержимое под ним.
 *
 * Заголовок стоит НАД карточками, а не внутри одной из них — так
 * в макете на всех экранах кабинета. Разница видна сразу: заголовок
 * внутри карточки читается как название этой карточки, а не раздела,
 * и «Валюты» перестаёт объединять шесть строк под собой.
 */
export function Section({ title, actions, children }: Props) {
  return (
    <section className={styles.section}>
      <header className={styles.head}>
        <h2 className={styles.title}>{title}</h2>
        {actions ? <div className={styles.actions}>{actions}</div> : null}
      </header>
      {children ? <div className={styles.body}>{children}</div> : null}
    </section>
  )
}
